document.addEventListener('DOMContentLoaded', function() {
	addAltsToNoAltImages();
	setTimeout(function() {
		addLabelsToMapPins();
	}, 1000);
});

function addAltsToNoAltImages() {
	const images = document.querySelectorAll('img:not([alt])');
	images.forEach(img => img.setAttribute('alt', ''));
}

function addLabelsToMapPins() {
	const pins = document.querySelectorAll('#wpgmza_map .gm-style div[role="button"]');
	pins.forEach(pin => pin.setAttribute('aria-label', 'Location Pin'));
}
